/* ================================================================
    MAIN ENTRY POINT - GLOBAL BUNDLE
    
    This file serves as the entry point for the global "all" bundle.
    It imports utilities first (to establish the talonUtil namespace),
    then imports the functions that depend on it.
================================================================ */
import { setup } from "./features/global/index.ts";

setup();
